<template>
  <div class="page-login">
    <div class="logo">
        <img src="/img/login/login-image-2.png" alt="">
      </div>
    <div class="login">
      <div class="box">
        <form class="form" @submit.prevent="veeFormSubmit">
          <div class="header">
            <div class="title-top"><img :src="logo" alt="" /></div>
            <div class="title">{{ title }}</div>
            <!-- <div class="desc">welcome to login system</div> -->
          </div>

          <div>
            <div class="tips" v-if="error.length > 0">
              <img src="/img/login/tip.png" alt="" />
              <span>{{ error }}</span>
            </div>
            <xc-form-item
              class="form-item"
              label=""
              hideError
              :error="errors.first('userName')"
            >
              <div class="icon">
                <img src="/img/login/username.png" />
              </div>
              <input
                v-validate="'required'"
                data-vv-as="账号"
                name="userName"
                type="text"
                class="xc-input"
                placeholder="请输入用户名"
              />
            </xc-form-item>
            <xc-form-item label="" hideError :error="errors.first('password')">
              <div class="icon">
                <img src="/img/login/password.png" />
              </div>
              <input
                v-validate="'required'"
                data-vv-as="密码"
                type="password"
                name="password"
                class="xc-input"
                placeholder="请输入密码"
              />
            </xc-form-item>
            <!-- <xc-form-item
                        label="验证码"
                        class="code"
                        >
                        <input
                            type="text"
                            class="xc-input"
                            placeholder="请输入验证码"
                            name="imageCode"
                        >
                        <img
                            :src="codeImg"
                            class="image-code"
                        >
                        </xc-form-item> -->
            <xc-form-item>
              <button class="btn-login xc-btn-l xc-btn-primary">登录</button>
            </xc-form-item>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>


<script>
import "@/utils/form-format"; // 表单格式化
import loadScript from "../utils/load-script";
import loginApi from "../api/login";
import "@/libs/vee-validate";
import { mapState, mapActions } from "vuex";
import material from "@/api/material";

export default {
  name: "Login",
  data() {
    return {
      index: null,
      // 验证码
      // codeImg: this.$config.apiUrl + '/image/code?width=66&height=26&key=superadmin',
      error: "",
      // logo: '/img/login/tip.png'
    };
  },
  async created() {
    localStorage.clear();
    sessionStorage.clear();
    await loadScript("/libs/md5.js");

    // 强制跳出iframe
    if (top.location != location) {
      top.location.href = location.href;
    }
  },
  async mounted() {},
  computed: {
    ...mapState(["globalConfig"]),
    title() {
      if (
        this.globalConfig.platform_name &&
        this.globalConfig.platform_name.value
      ) {
        return this.globalConfig.platform_name.value;
      }

      return null;
    },
    logo() {
      if (this.globalConfig.logo_url && this.globalConfig.logo_url.value) {
        return this.globalConfig.logo_url.value;
      }

      return null;
    },
  },
  methods: {
    // vee表单验证
    veeFormSubmit(e) {
      let that = this;

      this.$validator.validateAll().then((validate) => {
        if (validate) {
          const data = this.$formFormat(e.target);

          loginApi(data.userName, window.md5(data.password))
            .then(async (v) => {
              this.$message.success("登录成功");
              localStorage.token = v.data.token;

              let backUrl = this.$route.query.backUrl;
              if (backUrl) {
                backUrl = decodeURIComponent(backUrl);
              } else {
                const menuList = v.data.menu;

                let indexUrl;
                if (menuList[0].children && menuList[0].children.length) {
                  indexUrl = menuList[0].children[0].url;
                  localStorage.pageId = menuList[0].children[0].moduleId;
                  localStorage.pageParentId = menuList[0].children[0].pid;
                } else {
                  indexUrl = menuList[0].url;
                  localStorage.pageId = menuList[0].moduleId;
                  localStorage.pageParentId = menuList[0].pid;
                }

                backUrl = process.env.VUE_APP_ADMIN_PATH + indexUrl;
              }

              await material
                .getSessionToken()
                .then(function (success) {
                  sessionStorage.setItem("obs", JSON.stringify(success.data));
                })
                .catch(function (error) {
                  console.log(error);
                });

              setTimeout(() => {
                location.href = backUrl;
              }, 500);
            })
            .catch((e) => {
              that.error = e[0];
            });
          return;
        } else {
          this.error = "账号密码不能为空";
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.page-login {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
   background-color: #1C9AB4;
  // background: url("/img/login/new-bg.jpg") #060b11 no-repeat;
  // background-size: cover;
  // background-position: 0 100%;
}

.logo {
  text-align: center;
  // margin-bottom: 32px;
  // margin-top: -60px;
  img {
    width:80%;
    height: 70%;
    margin-left: 5%;
    // border: solid red 1px;
  }
}

.tips {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #6AC6BE;
  width: 100%;
  margin-bottom: 8px;
  // position: absolute;
  // left: 50%;
  // transform: translateX(-50%);
  // top:95px;
  // justify-content: center;
  img {
    height: 16px;
    width: 16px;
    margin-right: 6px;
  }
}

.btn-login {
  width: 280px !important;
  height: 40px !important;
  line-height: 40px;
  // background-color: #a13507;
  background-color: #fff;
  opacity: 0.7;
  color: #000;
  font-weight: bold;
  border-radius: 5px !important;
  word-spacing: 8px;
  margin-top: 20px;
}

// .code {
//     position: relative;
//     .image-code {
//         position: absolute;
//         right: -72px;
//         top: 3px;
//     }
// }
.login {
  position: relative;
  width: 100%;
  height: 100%;
}
.box {
  // background: url(/img/login/login-bg3.png) center center no-repeat;
  // background: rgba(255, 255, 255, 0.5);
  background-color: #b5b3b3b3;
  border-radius: 10px;
  width: 454px;
  height: 470px;
  position: absolute;
  right: 15%;
  top: 50%;
  margin-top: -235px;
  // margin-right: 5%;
  display: flex;
  align-items: center;
  justify-content: center;
  form {
    // position: absolute;
    // left: 64px;
    // top: 40px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header {
    margin-bottom: 40px;
    text-align: center;
    .title-top {
      img {
        max-height: 100px;
      }
    }
    .title {
      font-size: 32px;
      line-height: 32px;
      color: #ffffff;
      font-weight: bold;
      margin-top: 30px;
      opacity: 0.7;
    }
    .desc {
      font-size: 14px;
      color: #ffffff;
      opacity: 0.2;
    }
  }
}
</style>

<style lang="scss">
.page-login {
  .xc-form-item {
    margin-bottom: 20px;
  }
  .xc-form-item-label {
    display: none;
  }
  .xc-form-item-content {
    position: relative;
    line-height: 38px;

    .icon {
      position: absolute;
      left: 0;
      top: 0;
      margin-left: 12px;
      img {
        vertical-align: text-top;
        width: 22px;
      }
    }

    input {
      width: 280px !important;
      height: 40px !important;
      padding-left: 44px !important;
      font-size: 16px;
      border: solid 1px #fff;
      // background: #203a9c;
      background-color: transparent;
      color: #ffffff;
    }
    ::-webkit-input-placeholder {
      color: rgba(255, 255, 255, 0.3);
    } /* 使用webkit内核的浏览器 */
    :-moz-placeholder {
      color: rgba(255, 255, 255, 0.3);
    } /* Firefox版本4-18 */
    ::-moz-placeholder {
      color: rgba(255, 255, 255, 0.3);
    } /* Firefox版本19+ */
    :-ms-input-placeholder {
      color: rgba(255, 255, 255, 0.3);
    }

    .xc-input:focus {
      border: 0.05rem solid #e6e6e6;
    }

    //消除google浏览器黄色框
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus {
      background: transparent;
      box-shadow: 0 0 0 1000px transparent inset !important;
      -webkit-text-fill-color: #000;
    }
  }
}
input:-internal-autofill-previewed,
input:-internal-autofill-selected {
  -webkit-text-fill-color: #ffffff !important;
  transition: background-color 5000s ease-in-out 0s !important;
}
</style>
